import { useCallback, useEffect, useState } from "react"
import ApiService from "services/ApiService"
import Loader from "components/Loader"
import Button from "components/Button"
import Card from "components/Card"
import EventCard from "../ListCard"
import { useNavigate } from "react-router-dom"
import useApiHandler from "hooks/useApiHandler"

const UpcomingEvents = () => {
  const navigate = useNavigate()

  const [events, setEvents] = useState([])
  const { loading, request } = useApiHandler()

  const getUpcomingEvents = useCallback(async () => {
    request(
      {
        api: ApiService.getUpcomingEvents,
        body: null,
      },
      (response, err) => {
        if (err) return

        setEvents(response.data.events)
      }
    )
  }, [request])

  useEffect(() => {
    getUpcomingEvents()
  }, [getUpcomingEvents])

  const navigateTo = (to) => {
    navigate(to)
  }

  return (
    <section>
      <Loader open={loading} />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:max-w-[100rem] lg:px-8 mt-10 xs:flex-col justify-between md:flex">
        <div className="font-bold text-2xl">Upcoming Events</div>
        <div className="flex justify-between md:block mt-5 md:mt-0">
          <Button onClick={() => navigateTo("/current-events")}>Current Events</Button>
          <Button onClick={() => navigateTo("/previous-events")} className="ml-3">
            Previous Events
          </Button>
        </div>
      </div>

      <div className="mx-auto max-w-7xl py-2 px-4 sm:px-6 lg:max-w-[100rem] lg:px-8">
        <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {events.map((event, index) => (
            <EventCard event={event} key={index} refresh={getUpcomingEvents} />
          ))}
        </div>

        {!loading && events.length === 0 && (
          <Card className="text-center p-5">
            <h3 className="text-lg font-medium text-gray-700 ">No events found</h3>
          </Card>
        )}
      </div>
    </section>
  )
}

export default UpcomingEvents
